import React from 'react';

const About = () => {
    return (
        <div>
            <h3>from about</h3>
        </div>
    );
};

export default About;